import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const KEY = "nq_cart_v1";
const CartCtx = createContext(null);

function read() {
  try {
    const raw = localStorage.getItem(KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function CartProvider({ children }) {
  const [lines, setLines] = useState(read);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(lines));
  }, [lines]);

  const value = useMemo(() => {
    const count = lines.reduce((a, l) => a + l.qty, 0);
    return {
      lines,
      count,
      add(product, qty = 1) {
        setLines((prev) => {
          const i = prev.findIndex((l) => l.slug === product.slug);
          if (i >= 0) {
            const next = [...prev];
            next[i] = { ...next[i], qty: Math.min(99, next[i].qty + qty) };
            return next;
          }
          return [
            ...prev,
            {
              slug: product.slug,
              name: product.name,
              price: product.price,
              image: product.image,
              qty,
            },
          ];
        });
      },
      setQty(slug, qty) {
        setLines((prev) =>
          qty <= 0
            ? prev.filter((l) => l.slug !== slug)
            : prev.map((l) => (l.slug === slug ? { ...l, qty: Math.min(99, qty) } : l))
        );
      },
      remove(slug) {
        setLines((prev) => prev.filter((l) => l.slug !== slug));
      },
      clear() {
        setLines([]);
      },
      subtotal: lines.reduce((a, l) => a + Number(l.price || 0) * l.qty, 0),
    };
  }, [lines]);

  return <CartCtx.Provider value={value}>{children}</CartCtx.Provider>;
}

export function useCart() {
  const ctx = useContext(CartCtx);
  if (!ctx) throw new Error("useCart must be used inside CartProvider");
  return ctx;
}
